import React, { useContext, useRef } from 'react';
import TableCell from '@material-ui/core/TableCell';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import TableContext from '../TableContext';
import FilterButton from '../ColumnFilter/FilterButton';
import HeaderCellSortable from './HeaderCellSortable';
import { headerHeight } from '../constants';

const useStyles = makeStyles(theme => ({
  flexContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  tableRow: {
    cursor: 'pointer'
  },
  tableRowHover: {
    '&:hover': {
      backgroundColor: theme.palette.grey[200]
    }
  },
  tableCell: {
    flex: 1
  },
  noClick: {
    cursor: 'initial'
  }
}));

const Header = ({ label, columnData }) => {
  const classes = useStyles();
  const { getSortingForColumn, setSorting } = useContext(TableContext);
  const column = columnData.config;
  const sortDirection = getSortingForColumn(column.name);
  const tableCellRef = useRef();

  return (
    <TableCell
      component="div"
      className={cx(classes.tableCell, classes.flexContainer, classes.noClick)}
      variant="head"
      style={{ height: headerHeight }}
      ref={tableCellRef}
    >
      <HeaderCellSortable
        direction={sortDirection}
        sortable={column.sortable}
        columnName={column.name}
        onChangeSorting={setSorting}
      >
        {label}
      </HeaderCellSortable>
      <FilterButton column={column} tableCellRef={tableCellRef} />
    </TableCell>
  );
};

export default Header;
